import { useEffect, useState } from 'react';
import { recoverAccessToken } from 'components/shared/XpressId/services';
import { PRE_CANCELLED_STATUS } from 'constants/statusProcess';

import { ERROR_CODES } from 'constants/video/videoselfie';

export const useRecoverXpressIdAccessData = ({ clientId, token }, onError) => {
    const [{ accessToken, documentType }, setXpressIdAccessData] = useState({ accessToken: null, documentType: null });

    useEffect(() => {
        const handleFetchAccesToken = async () => {
            const { ok, data } = await recoverAccessToken(clientId, token);
            if (ok) return setXpressIdAccessData(data);
            onError({
                errorCode: ERROR_CODES.GENERIC_NETWORK_ERROR,
                status: PRE_CANCELLED_STATUS,
            });
        };
        void handleFetchAccesToken();
    }, [clientId]);

    return { accessToken, documentType };
};
